import { render } from "./FacturasFacturas.vue?vue&type=template&id=7eedad50&scoped=true"
import script from "./FacturasFacturas.vue?vue&type=script&lang=ts"
export * from "./FacturasFacturas.vue?vue&type=script&lang=ts"

import "./FacturasFacturas.vue?vue&type=style&index=0&id=7eedad50&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7eedad50"

export default script